import axios from "axios";
import { getAuthHeaders } from "./getAuthHeaders";

const REFRESH_CACHE_URL = "https://birdnest.muns.io/agents/library-admin/refresh-cache";

let refreshInFlight = null;
let lastRefreshTs = 0;
const REFRESH_COOLDOWN_MS = 1200;

const REFRESH_TRIGGER_RULES = [
  { method: "POST", path: "/agents/library" },
  { method: "DELETE", path: "/agents/library" },
  { method: "GET", path: "/agents/library-admin" },
  { method: "POST", path: "/agents/edit_agent_details" },
  { method: "POST", path: "/agents/dashboards" },
  { method: "GET", path: "/agents/dashboards-admin" },
  { method: "GET", path: "/agents/agent-library-admin-details/" },
  { method: "PATCH", path: "/agents/dashboards/" },
  { method: "DELETE", path: "/agents/dashboards/" },
];

function normalizeUrl(url = "") {
  return String(url).split("?")[0];
}

export function shouldRefreshOnApiRequest(method, url) {
  const normalizedMethod = String(method || "GET").toUpperCase();
  const normalizedUrl = normalizeUrl(url);
  return REFRESH_TRIGGER_RULES.some((rule) => {
    if (rule.method !== normalizedMethod) return false;
    return normalizedUrl.endsWith(rule.path) || normalizedUrl.includes(rule.path);
  });
}

/**
 * Triggers backend agent admin fetch to refresh cached agent data.
 * This should be called after create/update/delete/read operations
 * that affect agent list visibility.
 */
export async function refreshAgentCache() {
  const now = Date.now();
  if (refreshInFlight) return refreshInFlight;
  if (now - lastRefreshTs < REFRESH_COOLDOWN_MS) return null;

  refreshInFlight = (async () => {
  try {
    await axios.post(REFRESH_CACHE_URL, {}, {
      headers: {
        ...getAuthHeaders(),
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      _skipAgentRefresh: true,
    });
  } catch (err) {
    // Do not block user mutation flow if cache-refresh ping fails.
    console.error("Agent cache refresh call failed", err);
  } finally {
    lastRefreshTs = Date.now();
    refreshInFlight = null;
  }
  })();

  return refreshInFlight;
}
